import type { PayRunStatus } from '@thrivehrm/shared';
import { Badge } from '@/components/ui/badge';

const RUN_STATUS: Readonly<
  Record<PayRunStatus, { label: string; tone: 'neutral' | 'primary' | 'success' | 'warning' }>
> = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  SUBMITTED: { label: 'Submitted', tone: 'warning' },
  APPROVED: { label: 'Approved', tone: 'success' },
  DISBURSED: { label: 'Disbursed', tone: 'primary' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
};

/** Run status pill (DESIGN_SYSTEM §4: text always present, never colour alone). */
export function RunStatusBadge({ status }: { status: PayRunStatus }) {
  const { label, tone } = RUN_STATUS[status];
  return (
    <Badge tone={tone} data-status={status}>
      {label}
    </Badge>
  );
}
